export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/78489dd5fe22b2b724f99f5861a7cee7.svg";